module.exports = __webpack_public_path__ + "img/4f_r_twodays@2x.d8e014ef.jpg";